import { useRef, useEffect } from "react";
function useUpdateEffect(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) return effect();
    mounted.current = true;
    return void 0;
  }, deps);
}
export {
  useUpdateEffect as default
};
//# sourceMappingURL=useUpdateEffect.es.js.map
